export default "__VITE_ASSET__DhZru_Pb__"